import percentage from "calculate-percentages";
import settings from "../data/settings.json";
import { priceFormatter } from "./PriceFormatter";

export const depositCheck = (
  calculatedPropertyPurchasePrice,
  deposit,
  buyToLet,
  helpToBuy,
  firstHomes,
  firstHomesGreaterLondon,
  propertyRegionDetails,
) => {
  // borrow amount = x5 Income - result[0]
  // divide by .95
  const percent = buyToLet === 1 ? 20 : 5;

  const requiredDepositAmount = percentage.of(
    percent,
    calculatedPropertyPurchasePrice,
  );

  const getPriceCap = () => {
    return firstHomesGreaterLondon
      ? settings.firstHomes.priceCapLondon
      : settings.firstHomes.priceCap;
  };

  // Previously: no explicit 100% mortgage case. A deposit of 0 fell through to
  // the `requiredDepositAmount > deposit` branch, which is always true when deposit
  // is 0, producing a misleading warning about the 5% minimum.
  // Updated: return an info alert immediately when deposit is 0, so the user
  // sees a clear "100% mortgage" message instead of a deposit warning.
  if (Number(deposit) === 0)
    return [
      "info",
      <span>
        The results will be based on a{" "}
        <span className="font-bold">100% mortgage</span>.
      </span>,
      "white",
    ];

  return buyToLet === 1
    ? [
        "info",
        <span>
          Based on your calculated property purchase price, your deposit amount
          meets the minimum requirement of{" "}
          <span className="font-bold">20%</span> (
          {priceFormatter(requiredDepositAmount)}) for some buy to let mortgage
          lenders.
        </span>,
        "white",
      ]
    : firstHomes && deposit > getPriceCap()
    ? [
        "warning",
        <span>
          Your deposit is above the maximum property purchase price for the{" "}
          <span className="font-bold">First Homes</span> scheme.
          <br />
          Are you sure you require the{" "}
          <span className="font-bold">First Homes</span> scheme?
        </span>,
        "white",
      ]
    : requiredDepositAmount > deposit
    ? [
        "warning",
        <span>
          {/* Previously: helpToBuy === 1
             Updated: also accepts boolean true, as DepositChecker passes a boolean
             from (formData.schemes === "helpToBuy"). Standardisation of 1/0 vs
             true/false to be done as a separate task across the codebase. */}
          {helpToBuy === 1 || helpToBuy === true ? (
            <span>
              A minimum of <span className="font-bold">5%</span> deposit is
              required for the <span className="font-bold">Help to Buy</span>{" "}
              scheme
            </span>
          ) : (
            <span>Most mortgage lenders require a deposit of 5%</span>
          )}
          .<br />
          Based on your {firstHomes ? "discounted" : ""} calculated property
          purchase price a minimum deposit of{" "}
          <span className="font-bold">
            {priceFormatter(requiredDepositAmount)}
          </span>{" "}
          would be required.
          <br />
          <br />
          As your deposit is under 5%, you may be eligible for a 100% mortgage
          or a mortgage with a lower deposit requirement.
        </span>,
        "white",
      ]
    : [
        "success",
        <span>
          Based on your {firstHomes ? "discounted" : ""} calculated property
          purchase price, your deposit amount meets the minimum requirement of{" "}
          <span className="font-bold">5%</span> (
          {priceFormatter(requiredDepositAmount)}){" "}
          {/* Previously: helpToBuy === 1 — see comment above re: boolean vs integer */}
          {helpToBuy === 1 || helpToBuy === true ? (
            <span>
              for the <span className="font-bold">Help to Buy</span> scheme
            </span>
          ) : (
            <span>for some mortgage lenders</span>
          )}
          .
        </span>,
        "white",
      ];
};
